import { useQuery } from "react-query";
import { isQueryReady } from "src/api/axiosClient/utils";
import { fetchOrganizationGrid } from "./useGetAllOrganization";

export const organizationSuppliersKey = "getOrganizationSuppliers" as const;

type Options = {
    search?: string;
    additionalParams?: Record<string, unknown>;
};

export const useGetOrganizationSuppliers = (organizationId: number, options: Options = {}) => {
    const { search = "", additionalParams = {} } = options;

    const query = useQuery({
        queryKey: [organizationSuppliersKey, organizationId, search, JSON.stringify(additionalParams)],
        staleTime: 0,
        cacheTime: 0,
        queryFn: () =>
            fetchOrganizationGrid(
                `/api/organizations/${organizationId}/suppliers`,
                { q: search !== "" ? search : undefined, ...additionalParams },
                organizationSuppliersKey,
            ),
    });

    return {
        ...query.data,
        isReady: isQueryReady(query, true),
        ...query,
    };
};
